import { useContext } from 'react';
import ThemeContext from '../context/index.mjs';

// src/hooks/use-theme.ts
var useTheme = () => useContext(ThemeContext);
var use_theme_default = useTheme;

export { use_theme_default as default };
